import * as h2Api from '../h2Api'
import * as messageDialogActions from '../actions/messageDialog'

const initialState = {
  isOpened: false,
  byId: false,
  profile: null,
  subject: '',
  body: '',
  isSent: false
}
const messageDialog = (state = initialState, action) => {
  switch (action.type) {
    case messageDialogActions.OPEN_OR_CLOSE_MESSAGE_DIALOG:
      if (action.isOpened) {
        return {
          ...state,
          isOpened: true,
          byId: action.byId,
          byCriteria: action.byCriteria,
          profile: action.profile
        }
      }

      return { state: initialState.messageDialogState }

    case messageDialogActions.SEARCH_PUBLIC_PROFILES_SEND_MESSAGE:
      if (action.restCall.status === h2Api.REST_CALL_STATUS.RECEIVED) {
        return {
          ...state,
          isSent: true
        }
      }

      return state

    case messageDialogActions.SEARCH_PROFILE_MESSAGE_FORM_FIELD_CHANGE:
      return {
        ...state,
        [action.fieldName]: action.value
      }

    default:
      return state
  }
}

export default messageDialog
